import myController from './my-controller';

export default {
	myController
};
